export default __webpack_public_path__ + "static/media/ducks-unlimited.4dc94f72.png";